import React, { useEffect } from "react";
import {  useFormik } from "formik";
import { Grid } from "@mui/material";
import "../../components/style.scss"
import editIcon from "../../../../assets/icons/ic-solar_pen-bold.svg";
import { useDispatch, useSelector } from "react-redux";
import { applicantCountConstant } from "../../../../config/constant";
import TextFieldInput from "../../../../components/TextFieldInput";
import CommonButton from "../../../../shared-components/common-button/CommonButton";
import { setActiveStep, setReviewActiveStep } from "../../new-booking-form.slice";

const ApplicantReviewCard = () => {
  const applicantReviewFormik = useFormik({
    initialValues: {
      applicantDataList: [],
    },
  });

  const dispatch = useDispatch();
  const { applicantData, activeStep,reviewActiveStep } = useSelector(
    (state) => state?.newBookingForm
  );

  useEffect(() => {
    let applicatList = [];
    if (applicantData?.noOfApplicants) {
      for (let i = 1; i <= applicantData?.noOfApplicants; i++) {
        if (applicantData[`applicant${i}`] !== null) {
          applicatList.push({
            name: `${
              applicantData[`applicant${i}`]?.personalDetails?.firstName || ""
            } ${
              applicantData[`applicant${i}`]?.personalDetails?.lastName || ""
            }`,
            email:
              applicantData[`applicant${i}`]?.contactDetails?.emailAddress ||
              "",
            mobile:
              applicantData[`applicant${i}`]?.contactDetails?.contactNumber ||
              "",
            aadhaarNumber:
              applicantData[`applicant${i}`]?.personalDetails?.aadhaarNumber ||
              "",
            panNumber:
              applicantData[`applicant${i}`]?.personalDetails?.panNumber || 
              "",
            passportNumber:
              applicantData[`applicant${i}`]?.personalDetails?.passportNumber ||
              "",
            ociNumber:
              applicantData[`applicant${i}`]?.personalDetails?.ociNumber || 
              "",
            OCIAlternateDocType: 
              applicantData[`applicant${i}`]?.personalDetails?.OCIAlternateDocType || 
              "",
            countryCode : 
              applicantData[`applicant${i}`]?.contactDetails?.countryCode || 
              "",
          });
        }
      }
    }
    applicantReviewFormik.setFieldValue("applicantDataList", applicatList);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [applicantData]);

  const handleSaveForm = () => {
    dispatch(setReviewActiveStep(reviewActiveStep + 1));
  };

  const handlePrevious = () => {
    dispatch(setActiveStep(activeStep - 1));
  };

  return (
    <div className="applicantReviewCardContainer">
      <form onSubmit={applicantReviewFormik.handleSubmit} autoComplete="off">
        <Grid container spacing={2}>
          {applicantReviewFormik?.values?.applicantDataList &&
            applicantReviewFormik?.values?.applicantDataList?.map(
              (data, index) => {
                return (
                  <Grid key={index} item xs={12} sm={12} md={6} lg={6}>
                    <div className="box">
                    <div>
                      <div className="actionTop">
                        <div className="applicantNumber">
                          <span>
                            {index + 1 === 1 ? (
                              applicantCountConstant.numberKeys[1]
                            ) : (
                              <>
                                {index + 1}
                                <span className="textTop">
                                  <sup>{applicantCountConstant.numberKeys[index + 1]}</sup>
                                </span>
                              </>
                            )}{" "}
                            Applicant
                          </span>
                        </div>
                        <div
                          onClick={() => {
                            dispatch(setActiveStep(index));
                          }}
                          className="editIcon"
                        >
                          <img alt="" src={editIcon}></img>
                        </div>
                      </div>
                      
                        <div className="marginBottom24">
                          <TextFieldInput
                            sx={{ mb: 3 }}
                            field={{
                              name: "name",
                              label: "Name",
                              required: false,
                              readonly: true,
                              value: data?.name || "",
                            }}
                            formik={applicantReviewFormik}
                          />
                        </div>
                        <div className="marginBottom24">
                          <TextFieldInput
                            field={{
                              name: "email",
                              label: "Email",
                              required: false,
                              readonly: true,
                              value: data?.email || "",
                            }}
                            formik={applicantReviewFormik}
                          />
                        </div>

                        <div className="marginBottom24">
                          <TextFieldInput
                            field={{
                              name: "mobile",
                              label: "Mobile",
                              required: false,
                              readonly: true,
                              value: `${data?.countryCode + data?.mobile || ""}`,
                            }}
                            formik={applicantReviewFormik}
                          />
                        </div>
                        {data?.aadhaarNumber &&
                        data?.aadhaarNumber?.length > 0 ? (
                          <div className="marginBottom24">
                            <TextFieldInput
                              field={{
                                name: "aadhaarNumber",
                                label: "Aadhaar Number",
                                required: false,
                                readonly: true,
                                value: data?.aadhaarNumber || "",
                              }}
                              formik={applicantReviewFormik}
                            />
                          </div>
                        ) : null}
                        {data?.panNumber && data?.panNumber?.length > 0 ? (
                          <div className="marginBottom24">
                            <TextFieldInput
                              field={{
                                name: "panNumber",
                                label: "PAN Number",
                                required: false,
                                readonly: true,
                                value: data?.panNumber || "",
                              }}
                              formik={applicantReviewFormik}
                            />
                          </div>
                        ) : null}
                        {data?.passportNumber &&
                        data?.passportNumber?.length > 0 ? (
                          <div className="marginBottom24">
                            <TextFieldInput
                              field={{
                                name: "passportNumbe",
                                label: "Passport Number",
                                required: false,
                                readonly: true,
                                value: data?.passportNumber || "",
                              }}
                              formik={applicantReviewFormik}
                            />
                          </div>
                        ) : null}
                        {data?.ociNumber && data?.ociNumber?.length > 0 ? (
                          <div className="marginBottom24">
                            <TextFieldInput
                              field={{
                                name: "ociNumber",
                                label: "OCI Number",
                                required: false,
                                readonly: true,
                                value: data?.ociNumber || "",
                              }}
                              formik={applicantReviewFormik}
                            />
                          </div>
                        ) : null}
                        {data?.OCIAlternateDocType &&
                        data?.OCIAlternateDocType?.length > 0 ? (
                          <div>
                            <TextFieldInput
                              field={{
                                name: "OCIAlternateDocType",
                                label: "Other Document",
                                required: false,
                                readonly: true,
                                value: data?.OCIAlternateDocType || "",
                              }}
                              formik={applicantReviewFormik}
                            />
                          </div>
                        ) : null}
                    </div>
                    </div>
                  </Grid>
                );
              }
            )}
        </Grid>

        <CommonButton
          handleNext={handleSaveForm}
          handlePrevious={handlePrevious}
          saveDraftData={{
          }}
          saveForLater={false}
        />
      </form>
    </div>
  );
};

export default ApplicantReviewCard;
